import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './blog.css';
import img1 from "../../assets/blog-1.jpg"
import img2 from "../../assets/blog-2.jpg";
import img3 from "../../assets/blog-3.jpg"
import img4 from "../../assets/blog-4.jpg"
import img5 from "../../assets/blog-5.jpg"
import img6 from "../../assets/blog-6.jpg";
import img7 from "../../assets/blog-7.jpg"
import img8 from "../../assets/blog-8.jpg"
import img9 from "../../assets/blog-9.jpg"

const BlogDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const blogs = [
    {
      id: 1,
      image: img1,
      title: "طب أسنان الأطفال: ليه صحة الأسنان اللبنية مهمة؟",
      content: `أسنان الأطفال اللبنية أول ما تظهر، يبقى بداية رحلة طويلة لصحة الفم والأسنان. للأسف، فيه اعتقاد شايع إن الأسنان اللبنية مش مهمة لأنها بتتبدل، لكن الحقيقة إن صحتها بتأثر بشكل مباشر على صحة الأسنان الدائمة وحتى على نمو الفك وطريقة الكلام.

        <h4>ليه الأسنان اللبنية مهمة؟</h4>
        <ul>
          <li>الأسنان اللبنية بتحدد المسافات اللي الأسنان الدائمة هتظهر فيها. لو فيه تسوس أو فقدان مبكر للأسنان اللبنية، ده ممكن يسبب مشاكل في ترتيب الأسنان الدائمة.</li>
          <li>الأسنان اللبنية بيساعد الأطفال في المضغ والنطق الصحيح، وده ليه تأثير كبير على نموهم وصحتهم العامة.</li>
          <li>صحة الأسنان اللبنية بيعكس صحة الطفل العامة؛ اي مشاكل في الأسنان ممكن تكون علامة على سوء تغذية أو إهمال في العناية اليومية.</li>
        </ul>

        <h4>ايه اكتر مشاكل ممكن تواجه الأطفال؟</h4>
        <ul>
          <li>التسوس: أكتر مشكلة شائعة بين الأطفال، وغالباً بيكون بسبب استهلاك سكريات كتير وعدم تنظيف الأسنان كويس.</li>
          <li>تآكل الأسنان: بسبب عادات زي شرب العصائر الحمضية أو النوم بزجاجة اللبن في الفم.</li>
          <li>التهابات اللثة: نتيجة تراكم بقايا الطعام وإهمال التنظيف.</li>
        </ul>

        <h4>ازاي نحمي أسنان أطفالنا؟</h4>
        <ul>
          <li>تعليم الأطفال تنظيف الأسنان من سن صغير باستخدام فرشاة ومعجون مناسبين لعمرهم.</li>
          <li>زيارة دكتور الأسنان بانتظام، حتى لو مفيش مشكلة ظاهرة.</li>
          <li>تقليل استهلاك الحلويات والمشروبات السكرية، واستبدالها بوجبات صحية زي الفواكه والخضار.</li>
          <li>استخدام علاجات وقائية زي تطبيق الفلورايد أو الحشوات الوقائية للأسنان.</li>
        </ul>

        أسنان الأطفال اللبنية مش مجرد مرحلة مؤقتة، دي الأساس لصحة فمهم وأسنانهم في المستقبل. عشان كده، لازم نهتم بيها من بدري.`
    },
    {
      id: 2,
      image: img2,
      title: "جراحة الأسنان: خلع ضروس العقل ومشاكله",
      content: `ضروس العقل واحدة من أكثر الحاجات اللي بتسبب مشاكل في الأسنان، وكتير من الناس بيضطروا يشيلوها في مرحلة ما من حياتهم. بس ايه اللي بيخلي ضروس العقل تسبب ألم ومشاكل كبيرة كده؟

        <h4>ايه هي ضروس العقل؟</h4>
        ضروس العقل هي آخر مجموعة من الأسنان اللي بتظهر في الفم وعادة بتظهر بين سن 17 و25 سنة. المشكلة إن المساحة المتاحة للأسنان في الفك غالباً بتكون صغيرة، وده بيخلي الضروس دي تنمو بشكل غير طبيعي أو ما تطلعش أصلاً.

        <h4>ايه أشهر مشاكل ضروس العقل؟</h4>
        <ul>
          <li>انطمار الضروس: لما الضرس بيفضل تحت اللثة ومش بقدر يطلع بشكل كامل.</li>
          <li>ضغط على الأسنان التانية: بسبب قلة المساحة، ممكن ضرس العقل يضغط على الأسنان اللي جنبه ويسبب ألم أو يحركهم.</li>
          <li>التهابات وألم: نتيجة تراكم بقايا الأكل أو صعوبة تنظيف المنطقة حوالين الضرس.</li>
          <li>تسوس: لأن تنظيف ضروس العقل بيكون صعب جداً.</li>
        </ul>

        <h4>امتى لازم نشيل ضروس العقل؟</h4>
        لو الضرس بيسبب ألم مستمر، أو التهابات، أو مشاكل في ترتيب الأسنان، غالباً الدكتور هيقترح خلعه. في حالات كتير، بيتم خلع ضروس العقل حتى لو مفيش مشاكل حالياً كإجراء وقائي.

        <h4>ازاي بتتعمل العملية؟</h4>
        <ul>
          <li>خلع ضروس العقل ممكن يتم تحت تأثير تخدير موضعي أو كلي حسب كل حالة.</li>
          <li>العملية بتاخد من 30 دقيقة لساعتين حسب صعوبة الحالة.</li>
          <li>بعدها يحتاج المريض لراحة كام يوم مع الالتزام بتعليمات الطبيب.</li>
        </ul>

        خلع ضروس العقل مش مخيف زي ما ناس كتير بيتخيل، لكن المهم اننا نتابع مع دكتور متخصص لتجنب أي مضاعفات.`
    },
    {
      id: 3,
      image: img3,
      title: "زراعة الأسنان: الحل الأمثل لتعويض الأسنان المفقودة",
      content: `كتير من الناس بيفقدوا أسنانهم بسبب حوادث، تسوس، أو أمراض اللثة وده بيأثر على الشكل والقدرة على المضغ. زراعة الأسنان بقت النهاردة الحل الأفضل والأكثر تطورًا لتعويض الأسنان المفقودة.

        <h4>ايه هي زراعة الأسنان؟</h4>
        الزراعة عبارة عن تركيب جذور صناعية مصنوعة من التيتانيوم في عظم الفك، وبعد فترة بيتركب فوقها الأسنان الصناعية اللي بيكون شكلها ووظيفتها زي الأسنان الطبيعية تماماً.

        <h4>ايه مميزاتها؟</h4>
        <ul>
          <li>شكل طبيعي: محدش هيقدر يفرقها عن أسنانك الأصلية.</li>
          <li>ثبات قوي: بيديك إحساس بالأمان أثناء الأكل أو الكلام.</li>
          <li>عمر طويل: مع العناية الصحيحة، ممكن تستمر مدى الحياة.</li>
          <li>تحافظ على عظم الفك: الزراعة بتمنع فقدان العظم اللي بيحصل بعد خلع الأسنان.</li>
        </ul>

        <h4>ازاي بتتعمل الزراعة؟</h4>
        <ul>
          <li>أول خطوة هي فحص شامل للأسنان والفك باستخدام الأشعة.</li>
          <li>يتم تحضير العظم لو كان محتاج تطعيم.</li>
          <li>يتم زرع الجذر الصناعي، وبعدها بتستنى كام شهر لغاية ما يلتئم مع العظم.</li>
          <li>أخيراً، بيتركب التاج الصناعي فوق الجذر.</li>
        </ul>

        زراعة الأسنان حلت مشاكل كتير وخلت ناس كتير يستعيدوا تقتهم بنفسهم. لو عندك سن مفقود، متترددش في استشارة طبيب متخصص.`
    },
    {
      id: 4,
      image: img4,
      title: "تجميل الأسنان: ابتسامة هوليوود حلم ولا حقيقة؟",
      content: `الابتسامة المثالية بقت حلم عند كتير من الناس، وده بسبب تأثيره الكبير على الثقة بالنفس والجاذبية. ابتسامة هوليوود، أو ما يُعرف بالـHollywood Smile، هي واحدة من أكثر الإجراءات التجميلية شيوعًا في طب الأسنان. السؤال هنا: هل Hollywood Smile فعلاً ابتسامة هوليوود مناسبة لكل الناس؟

        <h4>إيه هي ابتسامة هوليوود؟</h4>
        ابتسامة هوليوود عبارة عن قشور تجميلية رقيقة جداً بيتم تركيب على سطح الأسنان الأمامي، القشور دي غالباً بتكون مصنوعة من البورسلين، وهدفها تحسين شكل الأسنان من ناحية اللون، الحجم، والترتيب.

        <h4>مميزات ابتسامة هوليوود</h4>
        <ul>
          <li>بتديك ابتسامة بيضاء ومتناسقة بشكل جمالي مثالي</li>
          <li>مع العناية الجيدة، القشور ممكن تستمر لأكثر من 10 سنوات</li>
          <li>البورسلين ما بيتأثرش بالقهوة، الشاي، او التدخين زي الأسنان الطبيعية</li>
          <li>في خلال زيارتين أو ثلاثة للطبيب، ممكن تحصل على إبتسامتك المثالية</li>
        </ul>

        <h4>إيه عيوبها؟</h4>
        <ul>
          <li>تكلفتها العالية: تكلفتها مش بسيطة</li>
          <li>إزالة جزء من مينا الأسنان: بعض الحالات بيحتاج إزالة طبقة رقيقة من سطح الأسنان لتركيب القشور</li>
          <li>مش لكل الحالات: لو عندك تسوسات أو مشاكل كبيرة في اللثة، لازم نعالج الأول قبل ما نبدأ في ابتسامة هوليوود</li>
        </ul>

        <h4>هل الإبتسامة مناسبة ليه؟</h4>
        ابتسامة هوليوود مناسبة للأشخاص اللي عندهم مشاكل بسيطة في شكل الأسنان زي:
        <ul>
          <li>الأسنان الملونة اللي ما بتستجيبش للتبييض</li>
          <li>الأسنان اللي فيها تآكل أو تكسر</li>
          <li>فراغات صغيرة بين الأسنان</li>
        </ul>

          <li>الأسنان اللي فيها تآكل أو تكسر</li>
          <li>فراغات صغيرة بين الأسنان</li>
        </ul>

        لكن لو عندك مشاكل في عضة الأسنان أو تسوسات عميقة، الإبتسامة دي مش هتكون هي الحل الأول. لازم نبدأ بعلاج المشكلات الأساسية.

        ابتسامة هوليوود بقت حلم سهل التحقيق مع التقدم في مجال تجميل الأسنان. بس المهم إنك تستشير طبيب متخصص يحدد المناسب ليك.`
    },
    {
      id: 5,
      image: img5,
      title: "الحشوات العادية: حل بسيط لمشكلة كبيرة",
      content: `
        الحشوات السنية من أكثر الاجراءات العلاجية شيوعاً في طب الأسنان. هي الحل المثالي لتعويض الأجزاء المفقودة من الأسنان بسبب التسوس أو الكسر. الحشوات العادية، على الرغم من بساطتها، دورها كبير جداً في الحفاظ على صحة الأسنان ووظيفتها.

        <h4>إيه هي الحشوة العادية؟</h4>
        الحشوة العادية هي مادة صلبة يتم وضعها مكان الجزء المتآكل أو المكسور من السن. الهدف منها هو استعادة وظيفة السن ومنع انتشار التسوس أو الضرر لباقي أجزاء السن.

        <h4>إيه أشهر أنواع الحشوات العادية؟</h4>
        <ul>
          <li>حشوة الاملغم (الفضية): مصنوعة من خليط من المعادن، وهي متينة جداً ومناسبة للأسنان الخلفية</li>
          <li>حشوة الكومبوزيت (البيضاء): لونها قريب جداً من لون الأسنان الطبيعية، لكنها أقل متانة من الاملغم</li>
        </ul>

        <h4>ازاي بتتعامل الحشوة مع التسوس؟</h4>
        الدكتور بيبدأ بتنظيف الجزء المصاب بالتسوس من السن باستخدام أدوات خاصة، بعد كده بيحضر السن لاستقبال الحشو.
        الحشوة بتكون مصممة عشان تتحمل ضغط المضغ وتستمر لفترة طويلة.

        <h4>إزاي نحافظ على الحشوات؟</h4>
        <ul>
          <li>تنظيف الأسنان يومياً باستخدام فرشاة ومعجون يحتوي على الفلورايد</li>
          <li>استخدام خيط الأسنان لتنظيف المناطق بين الأسنان</li>
          <li>تجنب أكل الحاجات الصلبية جداً زي الثلج أو اللب</li>
          <li>زيارة طبيب الأسنان بانتظام لفحص الحشوات والتأكد انها سليمة</li>
        </ul>

        الحشوات العادية هي الحل السريع والفعال لعلاج تسوس الأسنان، وبتساعدك تحافظ على أسنانك الطبيعية لأطول فترة ممكنة. المهم إنك تزور طبيب الأسنان أول ما تحس بأي مشكلة.`
    },
    {
      id: 6,
      image: img6,
      title: "حشو العصب: لما الألم يكون شديد الحل في العصب",
      content: `
        حشو العصب هو واحد من أكثر العلاجات المتقدمة في طب الأسنان، وبيعتبر الحل الوحيد لإنقاذ الأسنان اللي فيها تسوس عميق وصل لجذر السن. الألم الناتج عن التهابات العصب ممكن يكون شديد جداً، لكن مع وجود حشو العصب، الحل بقى أسهل بكتير.

        <h4>إيه هو حشو العصب؟</h4>
        حشو العصب هو عملية طبية بتنظيف جذور السن من الأنسجة التالفة أو المصابة، وبعد كده بيتم ملء القنوات بمادة خاصة عشان تحافظ على السن. الهدف هو إزالة الألم والحفاظ على الأسنان الطبيعية بدل خلعها.

        <h4>إيه أشهر أعراض التهاب العصب؟</h4>
        <ul>
          <li>ألم شديد في الأسنان، خصوصاً بالليل</li>
          <li>حساسية الأسنان للأكل أو المشروبات الساخنة والباردة</li>
          <li>تورم أو انتفاخ في اللثة حوالين السن المصاب</li>
          <li>تغير لون السن</li>
        </ul>

        <h4>إزاي بتتم عملية حشو العصب؟</h4>
        <ul>
          <li>تنظيف قناة الجذر من التسوس والبكتيريا</li>
          <li>توسيع وتنظيف القنوات باستخدام أدوات دقيقة</li>
          <li>ملء القنوات بمادة خاصة تمنع البكتيريا من الدخول تاني</li>
          <li>وضع حشوة دائمة أو تركيب تاج لحماية السن</li>
        </ul>

        حشو العصب هو الإجراء اللي بيحمي أسنانك من الخلع، وبيساعدك تحافظ على ابتسامتك وصحة فمك. لو حاسس بألم شديد أو عندك أي أعراض، متترددش تزور طبيبك.`
    },
    {
      id: 7,
      image: img7,
      title: "الحشوات التجميلية: حلول عملية لجمال أسنانك",
      content: `
        الابتسامة المثالية مش بس شكل الأسنان، لكن كمان لونها وتناسقها. الحشوات التجميلية بقت الحل الأمثل لتعويض أي فراغات أو تسوس بأسنانك مع الحفاظ على جمالها. دلوقتي تقدر تصلح سنك التالف من غير ما يبان إنك عملت حاجة.

        <h4>إيه هي الحشوة التجميلية؟</h4>
        الحشوات التجميلية مصنوعة من مادة الكمبوزيت، ودي مادة بتتشكل حسب لون وشكل أسنانك الطبيعية. بتستخدم لعلاج التسوس أو لإصلاح الكسور والتشققات البسيطة.

        <h4>مميزاتها عن الحشوات العادية</h4>
        <ul>
          <li>شكلها طبيعي: لونها مطابق تماماً للون الأسنان الطبيعية، فمحدش هيلاحظها</li>
          <li>سهولة التركيب: العملية بسيطة وما بتحتاجش وقت طويل</li>
          <li>مناسبة لكل الاعمار: الأطفال والكبار ممكن يستخدموها</li>
          <li>متينة: بتتحمل الضغط أثناء الأكل، خصوصاً في الأسنان الأمامية</li>
        </ul>

        <h4>إزاي بتتحط الحشوة التجميلية؟</h4>
        <ul>
          <li>تنظيف السن المصاب بالتسوس أو الكسر</li>
          <li>تجهيز سطح السن عشان الحشوة تلتصق كويس</li>
          <li>وضع المادة التجميلية وتشكيلها حسب شكل السن</li>
          <li>تسليط ضوء خاص لتثبيت المادة وضمان متانتها</li>
        </ul>

        <h4>إيه العناية اللي لازم نتبعها؟</h4>
        <ul>
          <li>تنظيف الأسنان يومياً باستخدام فرشاة ومعجون</li>
          <li>تجنب أكل الأكلات الصلبة جداً</li>
          <li>زيارة الطبيب بانتظام عشان تتأكد من سلامة الحشوة</li>
        </ul>

        الحشوات التجميلية مش بس علاج للأسنان، لكنها كمان خطوة لتعزيز ثقتك بنفسك. لو عندك مشكلة بسيطة في أسنانك، متترددش تستشير دكتور متخصص.`
    },
    {
      id: 8,
      image: img8,
      title: "تركيبات الأسنان: الحل الأمثل لتعويض الأسنان المفقودة",
      content: `
        فقدان الأسنان مشكلة بتأثر مش بس على الشكل، لكن كمان على القدرة على الأكل والكلام. تركيبات الأسنان هي واحدة من أفضل الحلول لتعويض الأسنان المفقودة، وبتقدم نتائج قريبة جداً للأسنان الطبيعية.

        <h4>إيه أنواع التركيبات؟</h4>
        <ul>
          <li>التركيبات الثابتة: زي الجسور أو التيجان اللي بتتثبت على الأسنان المجاورة أو فوق زراعات الأسنان</li>
          <li>التركيبات المتحركة: زي أطقم الأسنان الكاملة أو الجزئية اللي المريض يقدر يشيلها ويركبها بسهولة</li>
        </ul>

        <h4>إيه مميزات التركيبات؟</h4>
        <ul>
          <li>استعادة الشكل الطبيعي للإبتسامة</li>
          <li>تحسين القدرة على مضغ الأكل والنطق</li>
          <li>منع تحرك الأسنان المجاورة</li>
          <li>الحفاظ على عظام الفك ومنع تآكلها</li>
        </ul>

        <h4>إزاي بتتعمل التركيبات؟</h4>
        <ul>
          <li>فحص الأسنان واختيار النوع الأنسب</li>
          <li>أخد قياسات دقيقة باستخدام قوالب خاصة</li>
          <li>تركيب التركيبة المؤقتة، وبعدها الثابتة أو المتحركة حسب الحالة</li>
        </ul>

        <h4>نصائح للحفاظ على التركيبات</h4>
        <ul>
          <li>تنظيف التركيبات يومياً باستخدام الأدوات المناسبة</li>
          <li>تجنب الأطعمة الصلبة جداً</li>
          <li>زيارة الطبيب بشكل دوري للتأكد من سلامة التركيبة وصحة الفم</li>
        </ul>

        تركيبات الأسنان بقت حل عملي وفعال لاستعادة ثقتك بنفسك وصحة أسنانك. لو عندك أي فراغات أو مشاكل، متترددش في استشارة طبيبك.`
    },
    {
      id: 9,
      image: img9,
      title: "تقويم الأسنان الشفاف: حل عصري وفعال",
      content: `
        كتير من الناس بيخاف تعمل تقويم الأسنان بسبب الشكل اللي بيظهر بيه التقويم التقليدي. لكن دلوقتي التقويم الشفاف بقى حل مثالي وبيقدم نفس النتائج، مع شكله اللي ما بيتشافش تقريباً.

        <h4>إيه هو التقويم الشفاف؟</h4>
        هو تقويم متحرك مصنوع من مادة بلاستيكية شفافة، بيتصمم خصيصاً لكل مريض باستخدام تقنيات الكمبيوتر الحديثة. التقويم ده بيتغير كل فترة عشان يحرك الأسنان بالتدريج لغاية ما توصل للمكان المثالي.

        <h4>إيه مميزاته؟</h4>
        <ul>
          <li>لأنه شفاف، الناس مش هتلاحظ إنك لابس تقويم بشكله الجمالي</li>
          <li>مريح: مفيش أسلاك أو براكتات ممكن تضايق لثتك أو تسبب جروح</li>
          <li>سهولة الأكل: ممكن تخلعه أثناء الأكل وتشرب اللي انت عايزه بدون قلق</li>
          <li>سهولة التنظيف: التقويم بينشال بسهولة وده بيسهل تنظيفه وتنظيف الأسنان</li>
        </ul>

        <h4>هل التقويم الشفاف مناسب لكل الحالات؟</h4>
        للأسف مش كل الحالات بتتعالج بالتقويم الشفاف. الحالات البسيطة والمتوسطة هي الأنسب ليه، زي الفراغات أو إزدحام الأسنان البسيط. أما الحالات المعقدة، زي مشاكل الفكين، فالتقويم التقليدي بيبقى هو الحل الأفضل.

        <h4>إيه المطلوب عشان تبدأ العلاج؟</h4>
        أول حاجة هتعملها هي زيارة دكتور الأسنان. الطبيب هيعمل فحص شامل للأسنان، وياخد صور وأشعة عشان يحدد إذا كنت مناسب للتقويم الشفاف ولا لا. بعد كده، الطبيب هيبدأ يصمم خطة العلاج الخاصة بيك باستخدام برامج متطورة.

        العلاج بالتقويم الشفاف بيحتاج التزام كبير من المريض. لازم تلبسه على الأقل 20-22 ساعة يومياً عشان تحقق النتائج المطلوبة، ولازم تغيره حسب جدول الطبيب.

        الوقت اللي هتحتاج فيه التقويم بيعتمد على حالتك. فيه ناس بتبدأ تعمل تقويم في سن مبكر، من 7 ل 12 سنة، لأن الأسنان بتكون لسه في مرحلة النمو وده بيسهل تصحيحها. بس ده مش معناه إن الكبار ماينفعش يعملوا تقويم، بالعكس، فيه حلول ممتازة للكبار باستخدام تقنيات حديثة زي التقويم الشفاف.

        من الحاجات اللي لازم تبقى عارفها إن فترة العلاج بالتقويم بتختلف من شخص للتاني. ممكن تاخد من 6 شهور لغاية 3 سنين حسب الحالة. وكل ده بيحتاج متابعة مستمرة مع طبيب متخصص.

        وأخيراً، التقويم مش مجرد رفاهية، ده استثمار في صحتك وشكلك. الشكل النهائي للأسنان بعد التقويم مش بس بيديك ابتسامة أجمل، لكنه كمان بيحسن وظائف الفم بشكل عام.`
    }
  ];

  const blog = blogs.find(b => b.id === parseInt(id));

  if (!blog) {
    navigate('/');
    return null;
  }

  return (
    <div className="blog-details">
      <div className="container" style={{margin:'auto '}}>
        <div className="blog-content">
          <img src={blog.image} alt={blog.title} className="blog-image" />
          <div className="blog-text" dir="rtl">
            <h3>{blog.title}</h3>
            <div className="blog-body" dangerouslySetInnerHTML={{ __html: blog.content }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetails;
